import { render, staticRenderFns } from "./FixCategory.vue?vue&type=template&id=3b9b2d17&"
import script from "./FixCategory.vue?vue&type=script&lang=js&"
export * from "./FixCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports